const apikey = {
    USER_ID: '68OjB-xvXQmouXtq8',
    RESERVATION_TEMPLATE: 'template_xniit97'
}

export default apikey

// Petra
// service_l6tsdn7
// USER_ID: '68OjB-xvXQmouXtq8',
// RESERVATION_TEMPLATE: 'template_xniit97'

// Shiva
// USER_ID: 'user_KmWQvK32vEjLeYY3HI3mJ',
//     RESERVATION_TEMPLATE: 'template_pu24wrd'